import { Component, Input, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { AbstractSpecificFieldComponent } from '../abstract-specific-field.component';
import { OuiSelectOption } from 'omnium-ui/form-field';
import { OptionsService } from '@lib/services/options.service';

@Component({
    selector: 'app-objet-modification',
    templateUrl: './objet-modification.component.html',
    styleUrls: ['./objet-modification.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ObjetModificationComponent extends AbstractSpecificFieldComponent<string> {
  @Input() override touchNonce?: number;

  override getDataName(): string {
    return 'objetModification';
  }
  options: OuiSelectOption<string>[];

  constructor(private optionsService: OptionsService) {
    super();
    this.options = this.optionsService.getObjetModificationOptions();
  }

  override ngOnChanges(ch: SimpleChanges): void {
    super.ngOnChanges(ch);
  }
  override wrapData(value: string): string {
    return value;
  }
  override markAllAsTouched(): void {
    this.control.markAsTouched();
  }
}
